import { SubscriberGroupSectionType } from 'app/area/subscriber-groups/form/metroline/types';
import { selectorId } from 'app/area/shared/selector-id';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { SubscriberGroupsState } from '../types-store';
import { hasChanges } from './utils/has-changes';

export interface SubscriberGroupFormSelectorProps {
  id: number;
  shouldPrompt: boolean;
  section: SubscriberGroupSectionType;
}

type SubscriberGroupFormSelectors = { [T in keyof SubscriberGroupFormSelectorProps]?:
  (state: SubscriberGroupsState, props: DefaultContainerProps) => SubscriberGroupFormSelectorProps[T] };

export const selectors: SubscriberGroupFormSelectors = {
  shouldPrompt: ({ form }) =>
    hasChanges(form?.subscriberGroupItem, form?.originalSubscriberGroupItem),
  id: (_, { params }) => selectorId(params?.id),
  section: (_, { params }) =>
    params?.section || undefined
};
